class RestrictATC extends HTMLElement {
  constructor(){
    super();

    const script = this.querySelector('script');
    const data = script ? JSON.parse(script.innerText) : null;
    const addToCartBtn = this.querySelector('[data-js-product-add-to-cart]');
    const addToCartBtnText = this.querySelector('[data-js-product-add-to-cart-text]');

    const stickyATC = document.querySelector('.js-sticky-atc');

    if(stickyATC) {
      const stickyATCParent = stickyATC.closest('.pdp-sticky-atc');
      const stickyATCText = stickyATC.querySelector('.js-sticky-atc-text');
      stickyATCText.innerText = addToCartBtnText.innerText;
      const observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          stickyATCParent.classList.remove('hide');
        }
        else {
          stickyATCParent.classList.add('hide');
        }
      });
    
      observer.observe(addToCartBtn);

      $(document).on("click", '.js-sticky-atc', (e) => {
        addToCartBtn.click();
      })
    }

  }
}
if (!customElements.get('restrict-atc-by-location')){
  customElements.define('restrict-atc-by-location', RestrictATC);
}